module.exports = __webpack_public_path__ + "media/images/default_banner_3-3cf46addd447ed4817bc6e1c6ca20b7d.webp";